import { createContext, useContext } from 'react';

export type SectionsWithErrors = Record<string, boolean>;

interface FormErrorsContextValue {
  formMessage: string;
  sectionsWithErrors: SectionsWithErrors;
}

const FormErrorsContext = createContext<FormErrorsContextValue>({
  formMessage: '',
  sectionsWithErrors: {},
});

export const FormErrorsProvider = FormErrorsContext.Provider;

export const useFormMessage = () => {
  const { formMessage } = useContext(FormErrorsContext);
  return formMessage;
};

export const useSectionsWithErrors = () => {
  const { sectionsWithErrors } = useContext(FormErrorsContext);
  return sectionsWithErrors;
};
